export default __webpack_public_path__ + "static/media/balance@2x.1a01fd7d.png";